import { convertRgbToHex } from 'utils/colors'

export const getHex = value => {
    const strVal = String(value)

    let hex = null
    if (strVal.startsWith('rgb')) {
        const ranges = strVal.substring(strVal.indexOf('(') + 1, strVal.lastIndexOf(')')).split(',')
        hex = convertRgbToHex(ranges[0], ranges[1], ranges[2])
    } else {
        hex = strVal[0] === '#' ? strVal : `#${strVal}`
    }

    if (hex.match(/^#([0-9a-f]{3}){1,2}$/i)) return hex.toLowerCase()
    else return null
}
